import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar } from '@dixa/lib-shared-habla';
import { Link } from 'react-router-dom';
import { analytics } from 'app/utils/segment';
import styles from './contactsTableUser.module.scss';
export const ContactsTableUser = ({ name, avatarUser, }) => (_jsxs("div", Object.assign({ className: styles.root }, { children: [_jsx(Avatar, { user: avatarUser, size: "24" }), _jsx(Link, Object.assign({ to: `/contacts/user/${avatarUser.id}`, onClick: () => analytics.contactsCardViewUserClicked() }, { children: name }))] })));
export default ContactsTableUser;
